import angular from 'angular'

/**
 * Filter for getting the status of a gift card transaction
 *
 * @module webregister.filters.wrGiftCardTransactionStatus
 */
angular
  .module('webregister.filters')
  .filter('wrGiftCardTransactionStatus', function (vdTitleCaseFilter) {
    const STATUS: Record<string, string> = {
      ACTIVATION: 'Issued',
      REDEEMING: 'Redeemed',
      IMPORTING: 'Imported',
      VOIDING: 'Cancelled',
      REVERSING: 'Reversed',
      EXPIRING: 'Expired',
      RELOADING: 'Reloaded',
    }

    /**
     * Get the display status of a gift card transaction. Falls back to provided `type` if the status is unknown.
     *
     * @param  transactionType {String}
     *         The `type` of gift card transaction.
     *
     * @return {String} The display status of the given gift card transaction
     */
    return function (transactionType: string) {
      return STATUS[transactionType] || vdTitleCaseFilter(transactionType)
    }
  })
